export class StorageDocument {
    public prefix: string;
    public fileName: string;
    public size: number;
    public contentType: string;
    public uri: string;
}
